import { ref } from 'vue';
import { defineStore } from 'pinia';

import type { InitializeOptions as PleaseWidgetConfig } from '@/common/types';

/** Intersection keeps all `InitializeOptions` keys (e.g. `firebaseConfig`) in sync with `@/common/types`. */
type ExtendedWidgetConfig = PleaseWidgetConfig & {
  title?: string;
};

export const useConfig = defineStore('config', () => {
  const config = ref<Partial<ExtendedWidgetConfig>>();
  const setConfig = (newConfig: Partial<ExtendedWidgetConfig>) => {
    config.value = Object.assign({}, config.value, newConfig);
  };

  return { config, setConfig };
});
